import React from 'react';
import { ButtonLink } from '@youngcapital/component-library';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';
import EducationEntry from './EducationEntry';
import { addEntry, removeEntry } from '../helpers/utils';

const INITIAL_VALUES = {
  edu_type_id: ''
};

function EducationFieldset(props) {
  const newEntryValues = {
    _id: uuidv4(),
    ...INITIAL_VALUES
  };
  const { getFieldProps, t, optionsData, fetchEducationsList } = props;
  const fieldName = 'degrees';
  const { value } = getFieldProps(fieldName);

  const addEducationEntry = () =>
    addEntry({
      fieldProps: getFieldProps(fieldName),
      initialValues: newEntryValues
    });

  const removeEducationEntry = key =>
    removeEntry({
      fieldProps: getFieldProps(fieldName),
      key
    });
  const isOnlyField = value.length === 1;

  return (
    <>
      <h3>{t('fieldset_education.header')}</h3>
      {value.map(({ _id }, index) => (
        <EducationEntry
          fetchEducationsList={fetchEducationsList}
          index={index}
          key={_id}
          getFieldProps={getFieldProps}
          t={t}
          optionsData={optionsData}
          isOnlyField={isOnlyField}
          removeEducation={() => removeEducationEntry(_id)}
        />
      ))}
      <div className='mt-2x'>
        <ButtonLink
          type='button'
          variant='link'
          onClick={addEducationEntry}
          data-cy='add_education_entry'
          title='add-new-education-button'
        >
          {t('fieldset_education.add_education')}
        </ButtonLink>
      </div>
    </>
  );
}

EducationFieldset.initialValues = () => ({
  degrees: [
    {
      _id: uuidv4(),
      ...INITIAL_VALUES
    }
  ]
});

EducationFieldset.validationSchema = () => ({
  degrees: yup.array().of(
    yup.object().shape({
      edu_type_id: yup.string().required()
    })
  )
});

EducationFieldset.type = 'education';

EducationFieldset.propTypes = FIELDSET_PROPTYPES;

export default asFieldset(EducationFieldset, { optionsData: true });
